  document.addEventListener("DOMContentLoaded", function () {
    const cards = document.querySelectorAll("[data-aos]");

    // Check if elements are in viewport and add animation class
    function checkIfInView() {
      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const isInViewport =
          rect.top <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.bottom >= 0;

        if (isInViewport) {
          setTimeout(() => {
            card.classList.add("aos-animate");
          }, parseInt(card.getAttribute("data-aos-delay") || 0));
        }
      });
    }

    // Run once on load
    checkIfInView();

    // Add scroll event listener
    window.addEventListener("scroll", checkIfInView);
  });